<template>
    <div>
        <panel-competition-form-box class="mab16">
            <div class="col-12">
                <div class="register-layout">
                    <div class="register-layout__main">
                        <label class="mab8">Możliwość rejestracji anonimowej</label>
                        <panel-input-base-radio
                            v-for="option in anonymousOptions"
                            :key="option.value"
                            :value="anonymous"
                            name="register-anonymous"
                            :option="option"
                            @input="$emit('update:anonymous', $event)"
                        />
                    </div>
                    <div class="register-layout__side">
                        <p class="register-layout__hint">
                            Uczestnicy mogą mieć możliwość ukrycia swoich danych na listach startowej oraz wyników.
                        </p>
                    </div>
                </div>
            </div>
        </panel-competition-form-box>

        <panel-competition-form-box class="mab16">
            <div class="col-12">
                <div class="register-layout">
                    <div class="register-layout__main">
                        <div class="form__headline mab8">Pola dodatkowe w formularzu rejestracyjnym</div>
                        <p>
                            Jeśli chcesz pozyskać od uczestnika dane, które nie znajdują się w podstawowym formularzu
                            rejestracyjnym, dodaj dodatkowe pytania, na które uczestnik odpowie podczas rejestracji.
                        </p>
                    </div>
                    <div class="register-layout__side">
                        <p class="register-layout__hint">
                            Podstawowe dane rejestracyjne to: Imię i nazwisko, data urodzenia, płeć, miejscowość, kraj,
                            adres email, telefon, klub.
                        </p>
                    </div>
                </div>
            </div>
        </panel-competition-form-box>

        <panel-competition-register-input-item
            v-for="(input, index) in inputs"
            :key="input._key"
            :value="input"
            :index="index"
            :total="inputs.length"
            :classifications="classifications"
            :type-options="typeOptions"
            :validation-options="validationOptions"
            @input="onInputChange(index, $event)"
            @remove="$emit('remove', index)"
            @copy="$emit('copy', index)"
            @move-up="$emit('move-up', index)"
            @move-down="$emit('move-down', index)"
        />

        <div class="register-layout__actions mat16 mab16">
            <base-button btn2 @click="$emit('add')">UTWÓRZ PYTANIE DODATKOWE</base-button>
        </div>

        <div class="register-layout__actions register-layout__actions--end mat16 mab64">
            <base-button btn1 class="register-layout__save" :loading="saving" :disabled="saving" @click="$emit('save')">
                Zapisz
            </base-button>
        </div>
    </div>
</template>

<script>
    import PanelCompetitionFormBox from '@/components/PanelCompetitionFormBox';
    import PanelCompetitionRegisterInputItem from '@/components/PanelCompetitionRegisterInputItem';
    import PanelInputBaseRadio from '@/components/PanelInputBaseRadio';
    import { INPUT_TYPE_OPTIONS, VALIDATION_OPTIONS } from '@/constants/competitionRegisterInputs';

    export default {
        name: 'PanelCompetitionRegisterForm',
        components: {
            PanelCompetitionFormBox,
            PanelCompetitionRegisterInputItem,
            PanelInputBaseRadio,
        },
        props: {
            inputs: {
                type: Array,
                required: true,
            },
            anonymous: {
                type: String,
                required: true,
            },
            classifications: {
                type: Array,
                default: () => [],
            },
            saving: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                typeOptions: INPUT_TYPE_OPTIONS,
                validationOptions: VALIDATION_OPTIONS,
                anonymousOptions: [
                    { value: 'yes', title: 'Tak' },
                    { value: 'no', title: 'Nie' },
                ],
            };
        },
        methods: {
            onInputChange(index, next) {
                const inputs = [...this.inputs];
                inputs[index] = next;
                this.$emit('update:inputs', inputs);
            },
        },
    };
</script>

<style scoped>
    .register-layout {
        display: flex;
        flex-wrap: wrap;
        gap: 16px 30px;
        width: 100%;
        align-items: flex-start;
    }
    .register-layout__main {
        flex: 1 1 280px;
        min-width: 0;
    }
    .register-layout__side {
        flex: 0 1 220px;
        min-width: 0;
    }
    .register-layout__hint {
        margin: 0;
        line-height: 21px;
    }
    .register-layout__actions {
        display: flex;
        justify-content: center;
        width: 100%;
    }
    .register-layout__actions--end {
        justify-content: flex-end;
    }
    .register-layout__save {
        width: 100%;
        max-width: 320px;
    }
    @media (min-width: 992px) {
        .register-layout__main {
            flex: 1 1 0;
        }
        .register-layout__side {
            flex: 0 0 280px;
        }
    }
</style>
